import { all, takeLatest } from "redux-saga/effects";

import { types as modalsAnchorActions } from "@gc-npm/reducers.modals-reducer";
import { types as detailedProductActions } from "@/reducers/detailed-product-reducer";
import { types as getMyProductsActions } from "@/reducers/get-my-products-reducer";
import { types as MobileInsuranceActions } from "@/reducers/mobile-insurance-reducer";
import { types as devicesListActions } from "@/reducers/devices-list";
import { types as headerActions } from "@gc-npm/reducers.header-reducer";
import { types as mainActions } from "@gc-npm/reducers.main-reducer";
import { types as searcherActions } from "@/reducers/searcher";

import {
  initAnchorModalListener,
  addModal,
} from "@gc-npm/sagas.modals-saga";
import { getItem } from "@/sagas/detailed-product";
import { getMyProducts } from "@/sagas/get-my-products";
import { initGetDevicesListItems } from "@/sagas/devices-list";
import { getMobileInsurance } from "@/sagas/get-mobile-insurance";
import { getMobileInsuranceLegals } from "@/sagas/get-mobile-insurance-legals";
import { performAutocompleteQuery } from "@/sagas/searcher";
import {
  checkCPAndSetZones,
  setReadNotificationsSaga,
} from "@gc-npm/sagas.main-saga";

function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    takeLatest(detailedProductActions.GET_DETAILED_PRODUCT, getItem),
    takeLatest(getMyProductsActions.GET_MY_PRODUCTS_BEGINS, getMyProducts),
    takeLatest(devicesListActions.GET_DEVICES_INIT, initGetDevicesListItems),
    takeLatest(devicesListActions.GET_MORE_DEVICES_INIT, initGetDevicesListItems),
    takeLatest(searcherActions.INIT_AUTOCOMPLETE_QUERY, performAutocompleteQuery),
    takeLatest(
      MobileInsuranceActions.GET_MOBILE_INSURANCE_BEGINS,
      getMobileInsurance
    ),
    takeLatest(
      MobileInsuranceActions.GET_MOBILE_INSURANCE_LEGALS_BEGINS,
      getMobileInsuranceLegals
    ),
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
    // notifications
    takeLatest(
      mainActions.SET_READ_NOTIFICATIONS_INIT,
      setReadNotificationsSaga
    ),
  ]);
}

export default rootSaga;
